$( document ).ready(function() {
  
  $('.marquee-left').marquee({
    direction: 'left',
    duration: 40000,
    delayBeforeStart: 0,
    duplicated: true,
    gap: 0,
    startVisible: true
  });
  
  $('.single-slider .slide-list').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: true,
    slidesToScroll: 1,
    adaptiveHeight: true
  });

  $('.product-slider .product-list-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
   {
      breakpoint: 1361,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 801,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

$('.customer-slider .customer-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
});

// homepage featured collection section on tab changes slick not initializing
const featuredCollNavs = document.querySelectorAll('.featured-collections-navigation button');
featuredCollNavs.forEach(collNav => {
  collNav.addEventListener('click', function() {
    const targetId = collNav.getAttribute('data-id');
    const targetSection = document.getElementById(targetId);
    if (!targetSection) {
      console.warn('No element found with id:', targetId);
      return;
    }
    setTimeout(() => {
      const selectedItem = targetSection.querySelector('.featured-collections-carousel__item.is-selected');
      if (!selectedItem) {
        return;
      }
      const productSlider = selectedItem.querySelector('.product-slider .product-list-slider');
      if (productSlider && typeof jQuery !== 'undefined' && jQuery(productSlider).slick) {
        jQuery(productSlider).slick('refresh');
      }
    }, 500);
  });
});


});



